module.exports = __webpack_public_path__ + "img/TomMcGee-Real.bcfb817d.jpg";